import { Alert } from "@emanprague/ppaskit";
import Close from "@emanprague/ppaskit/dist/Icons/Close";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import ToastViewModel from "viewModels/toastViewModel";

const toastView: ViewComponent<ToastViewModel> = observer(({ vm }) => {
  if (!vm.message) {
    return null;
  }

  const content = <div dangerouslySetInnerHTML={{ __html: vm.message }} />;

  return (
    <Alert variant={vm.variant}>
      {content}
      <button className="close" onClick={vm.onClose}>
        <Close />
      </button>
    </Alert>
  );
});

export default registerView(toastView, ToastViewModel);
